import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Button,
  Input,
  Icon
} from 'semantic-ui-react'

const CardLabReportUX = (props: any) => {
    return(
      <div
        id="CardLabReportUX-div-0"
        style={{padding:"10px", minWidth: "max-content"}}>
        <div
          id="CardLabReportUX-div-15"
          style={{ paddingBottom: "10px" }}>
          
          <div
            id="CardLabReportUX-div-17"
            style={{ paddingBottom: "10px" }}>
            
            <div
              id="CardLabReportUX-div-19"
              style={{ fontSize: "1.2rem", fontWeight: "bold", padding:"0.35rem 0 0.35rem", display: "flex", justifyContent: "space-between"}}>
              
              <div
                id="CardLabReportUX-div-82">
                {props.titleName || "Lab Results"}
              </div>
              <div
                id="CardLabReportUX-div-83"
                style={{ display: props.showPatientInfo?"":"none"}}>
                
                <Icon
                  className="red"
                  id="CardLabReportUX-Icon-84"
                  link={true}
                  name="close"
                  onClick={props.onClose}>
                </Icon>
              </div>
            </div>
            <hr
              id="CardLabReportUX-hr-20">
            </hr>
          </div>
          <div
            id="CardLabReportUX-div-85"
            style={{ paddingBottom: "1rem" , display: props.showPatientInfo?"flex":"none"}}>
            
            <div
              id="CardLabReportUX-div-86"
              style={{fontWeight: "bold"}}>
              {props.languageUX === "en" ? "HN" : "เอชเอ็น"}
            </div>
            <div
              id="CardLabReportUX-div-87"
              style={{marginRight:"2px", paddingLeft: "5px"}}>
              {props.patientInfo?.hn}
            </div>
            <div
              id="CardLabReportUX-div-88"
              style={{fontWeight: "bold", marginLeft: "3%"}}>
              {props.languageUX === "en" ? "name" : "ชื่อ"}
            </div>
            <div
              id="CardLabReportUX-div-89"
              style={{marginRight:"2px", paddingLeft: "5px"}}>
              {props.patientInfo?.full_name}
            </div>
            <div
              id="CardLabReportUX-div-90"
              style={{fontWeight: "bold", marginLeft: "3%"}}>
              {props.languageUX === "en" ? "sex" : "เพศ"}
            </div>
            <div
              id="CardLabReportUX-div-91"
              style={{marginRight:"5px", paddingLeft: "5px"}}>
              {props.patientInfo?.gender==="M"?"ชาย":props.patientInfo?.gender==="F"?"หญิง":"ไม่ระบุ"}
            </div>
            <div
              id="CardLabReportUX-div-92"
              style={{fontWeight: "bold", marginLeft: "3%"}}>
              {props.languageUX === "en" ? "birthday" : "วันเกิด"}
            </div>
            <div
              id="CardLabReportUX-div-93"
              style={{marginRight:"5px", paddingLeft: "5px"}}>
              {props.patientInfo?.birthdate}
            </div>
          </div>
          <div
            id="CardLabReportUX-div-61"
            style={{display:"flex",  paddingBottom: "1rem",textWrap: "nowrap",marginRight: "115px"}}>
            
            <div
              id="CardLabReportUX-div-62"
              style={{fontWeight: "bold"}}>
              {props.languageUX === "en" ? "Lab ID:" : "รหัสห้องปฏิบัติการ:"}
            </div>
            <div
              id="CardLabReportUX-div-63"
              style={{marginRight:"10px", paddingLeft: "5px"}}>
              {props.selectedLabOrderWorking?.full_access_number}
            </div>
            <div
              id="CardLabReportUX-div-64"
              style={{fontWeight: "bold", marginLeft: "3%"}}>
              {props.languageUX === "en" ? "Order date and time:" : "วันเวลาที่สั่ง :"}
            </div>
            <div
              id="CardLabReportUX-div-65"
              style={{marginRight:"5px", paddingLeft: "5px"}}>
              {props.selectedLabOrderWorking?.date}
            </div>
            <div
              id="CardLabReportUX-div-66"
              style={{fontWeight: "bold", marginLeft: "3%"}}>
              {props.languageUX === "en" ? "Lab order status:" : "สถานะ lab order:"}
            </div>
            <div
              id="CardLabReportUX-div-67"
              style={{marginRight:"5px", paddingLeft: "5px"}}>
              {props.selectedLabOrderWorking?.status_name}
            </div>
            <div
              id="CardLabReportUX-div-68"
              style={{ fontWeight: "bold", marginLeft: "3%"}}>
              {props.languageUX === "en" ? " Order Received Date" : " วันเวลาที่รับออเดอร์ :"}
            </div>
            <div
              id="CardLabReportUX-div-69"
              style={ {marginRight:"5px", paddingLeft: "5px"}}>
              {props.arriveTime}
            </div>
            <div
              id="CardLabReportUX-div-70"
              style={{fontWeight: "bold", marginLeft: "3%"}}>
              {props.languageUX === "en" ? "Payment :" : "การชำระเงิน :"}
            </div>
            <div
              id="CardLabReportUX-div-71"
              style={ {width:"10%",marginRight:"5px", paddingLeft: "5px"}}>
              {props.selectedLabOrderWorking?.payment_status_label}
            </div>
          </div>
          <div
            id="CardLabReportUX-div-72"
            style={{display:"flex",  paddingBottom: "1rem" }}>
            
            <div
              id="CardLabReportUX-div-73"
              style={{fontWeight: "bold"}}>
              {props.languageUX === "en" ? "Prescribing physician:" : "แพทย์ผู้สั่ง :"}
            </div>
            <div
              id="CardLabReportUX-div-74"
              style={{marginRight:"2px", paddingLeft: "5px"}}>
              {props.selectedLabOrderWorking?.doctor_name}
            </div>
            <div
              id="CardLabReportUX-div-75"
              style={{fontWeight: "bold", marginLeft: "3%"}}>
              {props.languageUX === "en" ? "department :" : "แผนก :"}
            </div>
            <div
              id="CardLabReportUX-div-76"
              style={{marginRight:"2px", paddingLeft: "5px"}}>
              {props.selectedLabOrderWorking?.division_name}
            </div>
            <div
              id="CardLabReportUX-div-77"
              style={{fontWeight: "bold", marginLeft: "3%"}}>
              {props.languageUX === "en" ? "Remark:" : "หมายเหตุ:"}
            </div>
            <div
              id="CardLabReportUX-div-78"
              style={{marginRight:"5px", paddingLeft: "5px"}}>
              {props.selectedLabOrderWorking?.note}
            </div>
          </div>
        </div>
        <div
          id="CardLabReportUX-div-13"
          style={{display: "flex" }}>
          
          <Button
            color="blue"
            disabled={props.disabledAttachFile || false}
            id="CardLabReportUX-Button-5"
            loading={props.loadingPrint}
            onClick={props.onAttachFile}>
            {props.languageUX === "en" ? "Attach file" : "แนบไฟล์"}
          </Button>
          <Button
            color="violet"
            disabled={props.disabledLabReport || false}
            id="CardLabReportUX-Button-81"
            onClick={props.onLabReport}
            style={{display: props.hideButtonLabReport ? "none":""}}>
            {props.languageUX === "en" ? "Lab Report" : "รายงานการทดลอง"}
          </Button>
          <div
            id="CardLabReportUX-div-94">
            {props.buttonPrintLabResult}
          </div>
          <div
            id="CardLabReportUX-div-14"
            style={{flex: 1}}>
            
          </div>
          <Input
            id="CardLabReportUX-Input-11"
            onChange={props.changeUsername}
            placeholder="username"
            size="mini"
            style={{marginRight:"5px", display: "none"}}
            value={props.username}>
          </Input>
          <div
            id="CardLabReportUX-div-95"
            style={{display: "flex", alignItems: "center", marginRight: "0.5rem"}}>
            {props.languageUX === "en" ? "Password" : "รหัสผ่าน"}
          </div>
          <div
            id="CardLabReportUX-div-96"
            style={{marginRight:"5px"}}>
            {props.inputPassword}
          </div>
          <div
            id="CardLabReportUX-div-79"
            style={{marginRight:"5px"}}>
            {props.buttonSave}
          </div>
          <div
            id="CardLabReportUX-div-80">
            {props.buttonAuthorize}
          </div>
        </div>
        <div
          id="CardLabReportUX-div-59"
          style={{marginTop:"10px"}}>
          {props.tableReport}
        </div>
      </div>
    )
}


export default CardLabReportUX

export const screenPropsDefault = {"language":"EN"}

/* Date Time : Thu Nov 20 2025 07:17:11 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{padding:\"10px\", minWidth: \"max-content\"}"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "Button",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": "แนบไฟล์",
          "valueEN": "Attach file"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledAttachFile || false"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-Button-5"
        },
        "loading": {
          "type": "code",
          "value": "props.loadingPrint"
        },
        "onClick": {
          "type": "code",
          "value": "props.onAttachFile"
        },
        "size": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "Input",
      "parent": 13,
      "props": {
        "fluid": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-Input-11"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeUsername"
        },
        "placeholder": {
          "type": "value",
          "value": "username"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{marginRight:\"5px\", display: \"none\"}"
        },
        "value": {
          "type": "code",
          "value": "props.username"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-13"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\" }"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-14"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-15"
        },
        "style": {
          "type": "code",
          "value": "{ paddingBottom: \"10px\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-17"
        },
        "style": {
          "type": "code",
          "value": "{ paddingBottom: \"10px\" }"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-19"
        },
        "style": {
          "type": "code",
          "value": "{ fontSize: \"1.2rem\", fontWeight: \"bold\", padding:\"0.35rem 0 0.35rem\", display: \"flex\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "hr",
      "parent": 17,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-hr-20"
        }
      },
      "seq": 20,
      "void": true
    },
    {
      "from": null,
      "id": 59,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.tableReport"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-59"
        },
        "style": {
          "type": "code",
          "value": "{marginTop:\"10px\"}"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-61"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\",  paddingBottom: \"1rem\",textWrap: \"nowrap\",marginRight: \"115px\"}"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": null,
      "id": 62,
      "name": "div",
      "parent": 61,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสห้องปฏิบัติการ:",
          "valueEN": "Lab ID:"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-62"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": null,
      "id": 63,
      "name": "div",
      "parent": 61,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedLabOrderWorking?.full_access_number"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-63"
        },
        "style": {
          "type": "code",
          "value": "{marginRight:\"10px\", paddingLeft: \"5px\"}"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": null,
      "id": 64,
      "name": "div",
      "parent": 61,
      "props": {
        "children": {
          "type": "value",
          "value": "วันเวลาที่สั่ง :",
          "valueEN": "Order date and time:"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-64"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginLeft: \"3%\"}"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": null,
      "id": 65,
      "name": "div",
      "parent": 61,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedLabOrderWorking?.date"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-65"
        },
        "style": {
          "type": "code",
          "value": "{marginRight:\"5px\", paddingLeft: \"5px\"}"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": null,
      "id": 66,
      "name": "div",
      "parent": 61,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะ lab order:",
          "valueEN": "Lab order status:"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-66"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginLeft: \"3%\"}"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": null,
      "id": 67,
      "name": "div",
      "parent": 61,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedLabOrderWorking?.status_name"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-67"
        },
        "style": {
          "type": "code",
          "value": "{marginRight:\"5px\", paddingLeft: \"5px\"}"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": null,
      "id": 68,
      "name": "div",
      "parent": 61,
      "props": {
        "children": {
          "type": "value",
          "value": " วันเวลาที่รับออเดอร์ :",
          "valueEN": " Order Received Date"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-68"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", marginLeft: \"3%\"}"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": null,
      "id": 69,
      "name": "div",
      "parent": 61,
      "props": {
        "children": {
          "type": "code",
          "value": "props.arriveTime"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-69"
        },
        "style": {
          "type": "code",
          "value": " {marginRight:\"5px\", paddingLeft: \"5px\"}"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": null,
      "id": 70,
      "name": "div",
      "parent": 61,
      "props": {
        "children": {
          "type": "value",
          "value": "การชำระเงิน :",
          "valueEN": "Payment :"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-70"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginLeft: \"3%\"}"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "div",
      "parent": 61,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedLabOrderWorking?.payment_status_label"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-71"
        },
        "style": {
          "type": "code",
          "value": " {width:\"10%\",marginRight:\"5px\", paddingLeft: \"5px\"}"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": null,
      "id": 72,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-72"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\",  paddingBottom: \"1rem\" }"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": null,
      "id": 73,
      "name": "div",
      "parent": 72,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์ผู้สั่ง :",
          "valueEN": "Prescribing physician:"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-73"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": null,
      "id": 74,
      "name": "div",
      "parent": 72,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedLabOrderWorking?.doctor_name"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-74"
        },
        "style": {
          "type": "code",
          "value": "{marginRight:\"2px\", paddingLeft: \"5px\"}"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": null,
      "id": 75,
      "name": "div",
      "parent": 72,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก :",
          "valueEN": "department :"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-75"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginLeft: \"3%\"}"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": null,
      "id": 76,
      "name": "div",
      "parent": 72,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedLabOrderWorking?.division_name"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-76"
        },
        "style": {
          "type": "code",
          "value": "{marginRight:\"2px\", paddingLeft: \"5px\"}"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": null,
      "id": 77,
      "name": "div",
      "parent": 72,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเหตุ:",
          "valueEN": "Remark:"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-77"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginLeft: \"3%\"}"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": null,
      "id": 78,
      "name": "div",
      "parent": 72,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectedLabOrderWorking?.note"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-78"
        },
        "style": {
          "type": "code",
          "value": "{marginRight:\"5px\", paddingLeft: \"5px\"}"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": null,
      "id": 79,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-79"
        },
        "style": {
          "type": "code",
          "value": "{marginRight:\"5px\"}"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonAuthorize"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-80"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 81,
      "name": "Button",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": "รายงานการทดลอง",
          "valueEN": "Lab Report"
        },
        "color": {
          "type": "value",
          "value": "violet"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledLabReport || false"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-Button-81"
        },
        "onClick": {
          "type": "code",
          "value": "props.onLabReport"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideButtonLabReport ? \"none\":\"\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 82,
      "name": "div",
      "parent": 19,
      "props": {
        "children": {
          "type": "code",
          "value": "props.titleName || \"Lab Results\""
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-82"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": null,
      "id": 83,
      "name": "div",
      "parent": 19,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-83"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.showPatientInfo?\"\":\"none\"}"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 84,
      "name": "Icon",
      "parent": 83,
      "props": {
        "className": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-Icon-84"
        },
        "link": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "close"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClose"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": null,
      "id": 85,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-85"
        },
        "style": {
          "type": "code",
          "value": "{ paddingBottom: \"1rem\" , display: props.showPatientInfo?\"flex\":\"none\"}"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": null,
      "id": 86,
      "name": "div",
      "parent": 85,
      "props": {
        "children": {
          "type": "value",
          "value": "เอชเอ็น",
          "valueEN": "HN"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-86"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": null,
      "id": 87,
      "name": "div",
      "parent": 85,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientInfo?.hn"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-87"
        },
        "style": {
          "type": "code",
          "value": "{marginRight:\"2px\", paddingLeft: \"5px\"}"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": null,
      "id": 88,
      "name": "div",
      "parent": 85,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ",
          "valueEN": "name"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-88"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginLeft: \"3%\"}"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": null,
      "id": 89,
      "name": "div",
      "parent": 85,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientInfo?.full_name"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-89"
        },
        "style": {
          "type": "code",
          "value": "{marginRight:\"2px\", paddingLeft: \"5px\"}"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": null,
      "id": 90,
      "name": "div",
      "parent": 85,
      "props": {
        "children": {
          "type": "value",
          "value": "เพศ",
          "valueEN": "sex"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-90"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginLeft: \"3%\"}"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": null,
      "id": 91,
      "name": "div",
      "parent": 85,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientInfo?.gender===\"M\"?\"ชาย\":props.patientInfo?.gender===\"F\"?\"หญิง\":\"ไม่ระบุ\""
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-91"
        },
        "style": {
          "type": "code",
          "value": "{marginRight:\"5px\", paddingLeft: \"5px\"}"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "div",
      "parent": 85,
      "props": {
        "children": {
          "type": "value",
          "value": "วันเกิด",
          "valueEN": "birthday"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-92"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginLeft: \"3%\"}"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": null,
      "id": 93,
      "name": "div",
      "parent": 85,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientInfo?.birthdate"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-93"
        },
        "style": {
          "type": "code",
          "value": "{marginRight:\"5px\", paddingLeft: \"5px\"}"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPrintLabResult"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-94"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 95,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสผ่าน",
          "valueEN": "Password"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-95"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", marginRight: \"0.5rem\"}"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": null,
      "id": 96,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "code",
          "value": "props.inputPassword"
        },
        "id": {
          "type": "value",
          "value": "CardLabReportUX-div-96"
        },
        "style": {
          "type": "code",
          "value": "{marginRight:\"5px\"}"
        }
      },
      "seq": 94,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 50,
  "isMounted": false,
  "memo": false,
  "name": "CardLabReportUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "EN"
  },
  "width": 85
}

*********************************************************************************** */
